/**
 * @generated SignedSource<<d6e72df0a8bb58f321bbb554a8d51652>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type customizerTestConnectModelMutation$variables = {
  id: string;
  target: ModelDuplicateTargetInput;
};
export type customizerTestConnectModelMutation$data = {
  readonly connectModel: string;
};
export type customizerTestConnectModelMutation = {
  response: customizerTestConnectModelMutation$data;
  variables: customizerTestConnectModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "target"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "target",
        "variableName": "target"
      }
    ],
    "kind": "ScalarField",
    "name": "connectModel",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "customizerTestConnectModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "customizerTestConnectModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c01c00dbc1a1156d1e3ba9b17448178",
    "id": null,
    "metadata": {},
    "name": "customizerTestConnectModelMutation",
    "operationKind": "mutation",
    "text": "mutation customizerTestConnectModelMutation(\n  $id: ID!\n  $target: ModelDuplicateTargetInput!\n) {\n  connectModel(id: $id, target: $target)\n}\n"
  }
};
})();

(node as any).hash = "bb6ca1c5f3483ad984770bd94e5d92e8";

export default node;
